import _Label from 'admin/components/atoms/Label';
import React from 'react';
import styled from 'styled-components';
import Required from './Required';

type Props = {
  labelText: React.ReactNode;
  className?: string;
  required?: boolean;
  labelPosition?: 'left' | 'right';
  htmlFor?: string;
  children?: React.ReactNode;
};

const Wrapper = styled.div``;

const Label = styled(_Label)`
  margin: 0 5px;
`;

const Labeled = ({
  labelText,
  className = '',
  labelPosition = 'left',
  required = false,
  htmlFor,
  children,
}: Props) => {
  const label = (
    <Label htmlFor={htmlFor}>
      {required ? (
        <div>
          {labelText} <Required />
        </div>
      ) : (
        labelText
      )}
    </Label>
  );
  return (
    <Wrapper className={className}>
      {labelPosition === 'left' && label}
      {children}
      {labelPosition === 'right' && label}
    </Wrapper>
  );
};

export default styled(Labeled)<Props>``;
